/**
 * Structured logger that suppresses debug/info in production.
 * - debug: only in dev
 * - info: only in dev
 * - warn: always
 * - error: always
 */

const isProd = import.meta.env.PROD;

export const logger = {
  debug: (...args: unknown[]) => {
    if (!isProd) console.debug('[debug]', ...args);
  },
  info: (...args: unknown[]) => {
    if (!isProd) console.info('[info]', ...args);
  },
  warn: (...args: unknown[]) => {
    console.warn('[warn]', ...args);
  },
  error: (...args: unknown[]) => {
    console.error('[error]', ...args);
  },
};
